export default __webpack_public_path__ + "static/media/ui-kits.ebab46ac.svg";